import { ProductSpec } from "../interface"

export const powerArQPro: ProductSpec = {
  id: 'l0980',
  name: 'PowerArQ Pro',
  url:  process.env.GATSBY_TARGET_CHANNEL === 'rakuten' ? 'https://item.rakuten.co.jp/kashima-tokeiten/hte060/' : 'https://powerarq.com/products/hte060',
  capacity: 1000,
  batteryType: 'マンガン系',
  colors: [
    'coyote-tan',
    'olive-drab',
    'red',
  ],
  defaultColor: 'red',
  price: 132000,
  // salePrice: 105600,
  description: 'シリーズ最大容量モデル。通常1000W、瞬間最大2000Wの高出力に対応しているため、消費電力が高い機器や、できるだけ長時間の使用を求める方に',
  chargingTime: 7.5,
  chargingTimeWithSolar: { input: 150, value: 9 },
  chargingTimeWithCar: { input: 80, value: 17 },
  maximumOutput: 1000,
  smartphone: 85,
  electricBlanket: 17,
  fan: 28,
  ledLight: 283,
  riceCooker: 3.4,
  projector: 14,
  fridge: 28,
  electricCarpet: 4,
  electricPod: 3,
  drill: 50,
  hairDryer: { value: 50, override: { unit: '分' } },
  acPort: 3,
  usbA: 2,
  usbC: 2,
  weight: 10.4
}